import styled from "styled-components";

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  ${({ theme }) => theme.smartphone} {
    width: 90%;
  }
`;
